<template>
  <div>
    <v-select
      v-model="localValue"
      :items="currencyItems"
      item-text="code"
      item-value="iri"
      :label="label"
      :placeholder="placeholder"
      outlined
      dense
      :disabled="isUpdating"
      :error="hasError"
      :hide-details="hideDetails"
      :required="required"
      :loading="isUpdating"
      @input="onInput"
    />
  </div>
</template>

<script>
import ProductInfoFieldMixin from '@/mixins/ProductInfoFieldMixin';
import currencyMixins from '@/mixins/currencyMixins';

export default {
  name: 'LocalBookCurrencySelect',
  mixins: [ProductInfoFieldMixin, currencyMixins],
  props: {
    label: {
      type: String,
      default: 'Currency'
    },
    placeholder: {
      type: String,
      default: 'Select'
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    currencyItems() {
      return this.getCodesAndIris();
    },
    backendValue() {
      const currency = this.productInfoManager?.getData()?.book?.[this.fieldName];
      return currency?.id;
    }
  }
};
</script>
